import apiService from './apiService';

const PREFIX = '/skills';
const ADMIN_PREFIX = '/admin/skills';
const POLL_INTERVAL_MS = 4000;

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data;
}

const skillsService = {
  POLL_INTERVAL_MS,

  async list() {
    const data = await request(apiService.get(PREFIX));
    return Array.isArray(data.skills) ? data.skills : [];
  },

  async executer(slug, parametres = {}) {
    return request(apiService.post(
      `${PREFIX}/${encodeURIComponent(slug)}/executer`,
      { parametres },
      {},
      { timeout: 130000 },
    ));
  },

  async getExecution(id) {
    return request(apiService.get(`${PREFIX}/executions/${id}`));
  },

  async adminList() {
    const data = await request(apiService.get(ADMIN_PREFIX));
    return Array.isArray(data.skills) ? data.skills : [];
  },

  async adminCreate(body) {
    return request(apiService.post(ADMIN_PREFIX, body));
  },

  async adminUpdate(id, body) {
    return request(apiService.put(`${ADMIN_PREFIX}/${id}`, body));
  },

  async adminRemove(id) {
    return request(apiService.delete(`${ADMIN_PREFIX}/${id}`));
  },

  async adminTester(id, parametres = {}) {
    return request(apiService.post(
      `${ADMIN_PREFIX}/${id}/tester`,
      { parametres },
      {},
      { timeout: 130000 },
    ));
  },

  async adminExecutions({ page = 1, limit = 30, slug = '', statut = '', q = '' } = {}) {
    const res = await apiService.get(`${ADMIN_PREFIX}/executions`, {
      page,
      limit,
      slug,
      statut,
      q,
    });
    if (!res.success) {
      throw new Error(res.message || 'Erreur API');
    }
    return {
      executions: Array.isArray(res.data?.executions) ? res.data.executions : [],
      pagination: res.pagination || { page, limit, total: 0, pages: 0 },
    };
  },
};

export default skillsService;
